import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import emailjs from '@emailjs/browser'
import NavBar from '../components/NavBar'
import ModelViewer from '../components/ModelViewer'
import Footer from '../components/Footer'
import './Partners.css'

emailjs.init("S229Yq-pv37cz6Zb1");

const Partners = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    businessName: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    try {
      const result = await emailjs.send(
        'block_automation_service',  // Get this from EmailJS dashboard
        'template_rpvvyff', // Get this from EmailJS dashboard
        formData,
        'S229Yq-pv37cz6Zb1'   // Get this from EmailJS dashboard
      )

      if (result.text === 'OK') {
        alert('Message sent successfully!')
        // Clear form
        setFormData({
          name: '',
          email: '',
          businessName: '',
          message: ''
        })
      } else {
        alert('Failed to send message. Please try again.')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('An error occurred. Please try again later.')
    }
  }

  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div className="getstarted-container">
      <Helmet>
        <title>Get Started - block automation</title>
        <meta property="og:title" content="Get Started - block automation" />
        <meta property="og:description" content="Get started with block automation" />
      </Helmet>
      <NavBar />
      
      {/* Get Started Section (from home.js) */}
      <div className="getstarted-section section-container" style={{
        backgroundImage: `url(${publicUrl}/enclosure_2.png)`,
        backgroundPosition: 'right center',
        backgroundSize: '60%',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="getstarted-max-width max-width">
          <div className="getstarted-content">
            <span className="getstarted-text beforeHeading">get started</span>
            <h1 className="getstarted-text-title">
              <span>
                Ready to enhance your venue with 
                <span dangerouslySetInnerHTML={{ __html: ' ' }} />
              </span>
              <strong style={{ color: '#FBB040' }}>Sun Blocks</strong>
              <span>?</span>
            </h1>
            <div className="getstarted-step">
              <div className="getstarted-number">
                <span className="getstarted-step-number">1</span>
              </div>
              <div className="getstarted-container-step">
                <span className="getstarted-title-step">
                  <span>
                    Fill out the
                    <span dangerouslySetInnerHTML={{ __html: ' ' }} />
                  </span>
                  <span className="getstarted-text-orange">contact form</span>
                  <span> below</span>
                </span>
                <span className="getstarted-description">
                  We'll get back to you within 24 hours to discuss how we can help your guests stay protected.
                </span>
              </div>
            </div>
            <div className="getstarted-step">
              <div className="getstarted-number">
                <span className="getstarted-step-number">2</span>
              </div>
              <div className="getstarted-container-step">
                <span className="getstarted-title-step">
                  <span>
                    Schedule a
                    <span dangerouslySetInnerHTML={{ __html: ' ' }} />
                  </span>
                  <span className="getstarted-text-orange">
                    friendly demo
                  </span>
                </span>
                <span className="getstarted-description">
                  We'll show you how <strong style={{ color: '#FBB040' }}>Sun Blocks</strong> works and answer any questions you have about implementation at your venue.
                </span>
              </div>
            </div>
            <div className="getstarted-step">
              <div className="getstarted-number">
                <span className="getstarted-step-number">3</span>
              </div>
              <div className="getstarted-container-step">
                <span className="getstarted-title-step">
                  <span>
                    Try it
                    <span dangerouslySetInnerHTML={{ __html: ' ' }} />
                  </span>
                  <span className="getstarted-text-orange">risk-free</span>
                </span>
                <span className="getstarted-description">
                  We're happy to let you trial a <strong style={{ color: '#FBB040' }}>Sun Blocks</strong> dispenser at no cost so you can see firsthand how your guests love this amenity.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Contact Form Section (from contact.js) */}
      <div className="getstarted-form-container section-container">
        <div className="max-width">
          <div className="getstarted-form-content">
            <h1 className="getstarted-form-title">Schedule Your Demo</h1>
            <p className="getstarted-form-description">
              Let us show you how <strong style={{ color: '#FBB040' }}>Sun Blocks</strong> can enhance your guest experience and provide a valuable amenity to your venue.
            </p>
            <form className="getstarted-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name</label>
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Business Name</label>
                <input 
                  type="text" 
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  placeholder="Your business name" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your venue and what you're looking for" 
                  required
                ></textarea>
              </div>
              <button type="submit" className="button button-primary">
                Schedule My Demo
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Partners
